<template>
  <div v-if="totalPages > 1" class="flex items-center justify-center gap-1 mt-6">
    <!-- Previous button -->
    <button
      @click="goToPage(currentPage - 1)"
      :disabled="currentPage === 1"
      class="px-3 py-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
    >
      &lt;
    </button>

    <!-- Page buttons -->
    <template v-for="page in visiblePages" :key="page">
      <span v-if="page === '...'" class="px-2 text-gray-400">...</span>
      <button
        v-else
        @click="goToPage(page)"
        class="px-3 py-1 rounded min-w-[2.5rem]"
        :class="[
          page === currentPage
            ? 'bg-primary-500 text-white font-bold'
            : 'hover:bg-gray-100 font-light',
        ]"
      >
        {{ page }}
      </button>
    </template>

    <!-- Next button -->
    <button
      @click="goToPage(currentPage + 1)"
      :disabled="currentPage === totalPages"
      class="px-3 py-1 rounded hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed"
    >
      &gt;
    </button>
  </div>
</template>

<script>
export default {
  name: "Pagination",

  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    siblingCount: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    visiblePages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const siblings = this.siblingCount;

      // Always show first and last page
      // Show siblings around current page
      // Use ellipsis for gaps

      const pages = [];

      // Calculate range around current page
      const leftSibling = Math.max(current - siblings, 1);
      const rightSibling = Math.min(current + siblings, total);

      const showLeftEllipsis = leftSibling > 2;
      const showRightEllipsis = rightSibling < total - 1;

      // First page
      pages.push(1);

      // Left ellipsis
      if (showLeftEllipsis) {
        pages.push("...");
      } else if (leftSibling === 2) {
        pages.push(2);
      }

      // Pages around current
      for (let i = leftSibling; i <= rightSibling; i++) {
        if (i !== 1 && i !== total) {
          pages.push(i);
        }
      }

      // Right ellipsis
      if (showRightEllipsis) {
        pages.push("...");
      } else if (rightSibling === total - 1) {
        pages.push(total - 1);
      }

      // Last page
      if (total > 1) {
        pages.push(total);
      }

      return pages;
    },
  },

  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.$emit("page-change", page);
      }
    },
  },
};
</script>
